import type { SVGProps } from "react";
export interface Virus01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Virus01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Virus01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12 6.125a5.876 5.876 0 0 0-5.875 5.876l.007.301a5.876 5.876 0 0 0 5.565 5.565l.304.008.301-.008a5.875 5.875 0 0 0 5.565-5.565l.008-.301-.008-.304A5.875 5.875 0 0 0 12 6.125m8.875 7.376v-.375h-.83a8.1 8.1 0 0 1-1.561 3.767l.587.587.265-.265a1.125 1.125 0 1 1 1.591 1.591l-2.12 2.121a1.125 1.125 0 0 1-1.592-1.59l.265-.266-.587-.587a8.1 8.1 0 0 1-3.768 1.56v.83h.376a1.126 1.126 0 0 1 0 2.25h-3a1.125 1.125 0 0 1 0-2.25h.375v-.83a8.1 8.1 0 0 1-3.77-1.56l-.585.587.265.265.076.085a1.125 1.125 0 0 1-1.582 1.584l-.085-.078-2.123-2.12-.076-.087a1.124 1.124 0 0 1 1.582-1.582l.085.077.265.265.586-.587a8.1 8.1 0 0 1-1.56-3.768h-.829v.376a1.125 1.125 0 0 1-2.25 0v-3a1.125 1.125 0 1 1 2.25 0v.375h.83a8.1 8.1 0 0 1 1.56-3.771l-.587-.586-.265.267a1.126 1.126 0 0 1-1.59-1.591l1.06-1.062 1.062-1.06a1.126 1.126 0 0 1 1.59 1.59l-.266.265.586.586a8.1 8.1 0 0 1 3.77-1.56v-.829h-.374a1.125 1.125 0 1 1 0-2.25h3l.114.006a1.125 1.125 0 0 1 0 2.238l-.114.006h-.375v.83a8.1 8.1 0 0 1 3.767 1.56l.587-.587-.265-.265-.077-.085a1.126 1.126 0 0 1 1.583-1.582l.085.076 2.121 2.123.078.085a1.126 1.126 0 0 1-1.584 1.582l-.085-.076-.265-.265-.587.585a8.1 8.1 0 0 1 1.561 3.77h.83V10.5a1.125 1.125 0 0 1 2.25 0v3a1.125 1.125 0 0 1-2.25 0Z"
      />
      <path
        fill={color}
        d="M14.718 9.385a2.126 2.126 0 0 1-.219 4.24c-1.1 0-2.004-.836-2.113-1.908l-.01-.216.01-.219A2.126 2.126 0 0 1 14.5 9.375zM12.376 15a1.376 1.376 0 0 1-2.744.14L9.625 15l.007-.14A1.376 1.376 0 0 1 11 13.623l.14.008c.694.07 1.236.656 1.236 1.368Zm-2.002-4a1.375 1.375 0 0 1-2.742.14L7.625 11l.007-.141a1.375 1.375 0 0 1 1.369-1.234l.14.008c.693.07 1.233.655 1.233 1.367"
      />
    </svg>
  );
}
